import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveDeviceMutation = gql`
   mutation SaveDevice($device: DeviceInput!, $deletedHandsetKeysIds: [UInt!]!, $hasDeletedHandsets: Boolean = false) {
      deleteBaseStationHandsets(ids: $deletedHandsetKeysIds) @include(if: $hasDeletedHandsets)
      device: saveDevice(device: $device) {
         deviceId
         deviceTypeId
         accountId
         description
         macAddress
         serialNumber
         lastFirmwareReported
         lastProvisionedDate
         ztStatus
         notes
         baseStationHandsetsConnection {
            items {
               baseStationHandsetId
               phoneId
               deviceId
               sortId
            }
         }
      }
   }
`;
